import React from 'react';
import ChatAssistView from '../components/ChatAssistView';
import ChatAssistV2 from '../components/NewVersion/ChatAssistV2';
import { Redirect } from 'react-router-dom';
import { useShouldShowChatAssistRedirect } from 'features/chatAssist/ChatAssistHook';
const ChatAssist = () => {
  const { loading, enabled: isEnabled, version } = useShouldShowChatAssistRedirect();

  if (loading) return null;

  return isEnabled ? version === 1 ? <ChatAssistView /> : <ChatAssistV2 /> : <Redirect to="/" />;
};

export default ChatAssist;
